import React, { useEffect, useState } from "react";
import AppContainer from "../../Components/Accounting/AppContainer";
import DataTable from "../../Components/Accounting/DataTable";
import ExportBar from "../../Components/Accounting/ExportBar";
import Select from "react-select";
import ajaxAccounting from "../../util/accounting/remote/ajaxAccounting";
import functions from "../../util/accounting/functions";
import toast, { Toaster } from "react-hot-toast";

const ENTITY_TYPES = [
  { value: "", label: "All Entities" },
  { value: "acc_journal_entries",  label: "Journal Entries" },
  { value: "acc_invoices",          label: "Invoices" },
  { value: "acc_vouchers",          label: "Vouchers" },
  { value: "acc_accounts",          label: "Accounts" },
  { value: "acc_contacts",          label: "Contacts" },
  { value: "acc_employees",         label: "Employees" },
  { value: "acc_students",          label: "Students" },
];

const RecordKeeper = () => {
  const [records,  setRecords]  = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [entity,   setEntity]   = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate,   setToDate]   = useState("");
  const [search,   setSearch]   = useState("");

  useEffect(() => { fetchRecords(); }, [entity, fromDate, toDate]);

  const fetchRecords = async () => {
    setLoading(true);
    const res = await ajaxAccounting.listRecords({
      table_name: entity?.value || undefined,
      from_date:  fromDate || undefined,
      to_date:    toDate   || undefined,
      page: 1,
    });
    if (res.status === "OK") {
      setRecords(Array.isArray(res.details) ? res.details : res.details?.list || []);
    } else toast.error(res.message);
    setLoading(false);
  };

  const columns = [
    { key: "table_name",  label: "Entity",      render: (v)    => <code className="tx-12">{v}</code> },
    { key: "record_id",   label: "Record ID",   render: (v)    => <strong>#{v}</strong> },
    { key: "action",      label: "Action",      render: (v)    => {
      const colors = { CREATE:"success", UPDATE:"warning", DELETE:"danger", POST:"primary", APPROVE:"info" };
      return <span className={`badge bg-${colors[v?.toUpperCase()] || "secondary"}`}>{v}</span>;
    }},
    { key: "description", label: "Description", render: (v)    => <span className="tx-12">{v}</span> },
    { key: "created_by_name", label: "By",      render: (v)    => v || "—" },
    { key: "created_at",  label: "When",        render: (v)    => v ? new Date(v).toLocaleString("en-GB") : "—" },
    { key: "id",          label: "",            render: (_, row) => (
      row.before_data || row.after_data ? (
        <button className="btn btn-sm btn-light" onClick={() => {
          const msg = `BEFORE:\n${JSON.stringify(row.before_data, null, 2)}\n\nAFTER:\n${JSON.stringify(row.after_data, null, 2)}`;
          window.alert(msg);
        }} title="View Changes"><i className="fa-solid fa-code"></i></button>
      ) : null
    )},
  ];

  const exportCols = [
    { key:"table_name",label:"Entity" }, { key:"record_id",label:"Record ID" },
    { key:"action",label:"Action" }, { key:"description",label:"Description" },
    { key:"created_by_name",label:"By" }, { key:"created_at",label:"When" },
  ];

  return (
    <AppContainer title="Record Keeper" previousPageTitle="Accounting"
      description="A snapshot history of all data changes in the system. Every create, update, delete, and post action is captured here for compliance and recovery purposes."
    >
      <Toaster />
      <div className="card custom-card p-3 mb-3">
        <div className="row g-2">
          <div className="col-lg-3">
            <label className="form-label tx-12 fw-semibold">Entity</label>
            <Select options={ENTITY_TYPES} value={entity} onChange={setEntity} placeholder="All Entities" isClearable />
          </div>
          <div className="col-lg-3">
            <label className="form-label tx-12 fw-semibold">From Date</label>
            <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
          </div>
          <div className="col-lg-3">
            <label className="form-label tx-12 fw-semibold">To Date</label>
            <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
          </div>
        </div>
      </div>
      <div className="card custom-card p-3">
        <ExportBar data={records} columns={exportCols} filename="record-keeper" pdfTitle="Record Keeper Log"
          printCode="ACC-RECORDS" exportCode="ACC-RECORDS" />
        <DataTable columns={columns} data={records} loading={loading} pageSize={20} emptyMessage="No records found." />
      </div>
    </AppContainer>
  );
};

export default RecordKeeper;
